module.exports = __webpack_public_path__ + "img/fran.a3078dda.png";